import { createSelector } from 'reselect';
import { allTerms } from 'selectors/terms';
import { selectCurrentTermSections } from 'selectors/section';
import { isInstructorInSection } from 'selectors/current_user';
import { selectSection } from '../section';

export default (state, { params: { sectionId }, location: { pathname } }) =>
    createSelector(
        [allTerms, selectCurrentTermSections],
        allTerms => {
            const section = selectSection(state, sectionId);
            return {
                isInstructor: isInstructorInSection(state, section),
                currentPath: pathname,
                section,
            };
        }
    )(state);



// WEBPACK FOOTER //
// ./src/selectors/component_selectors/section_view_selector.js